// extracted by mini-css-extract-plugin
export default {"main":"CustomScroller_main__4IHTX","track":"CustomScroller_track__AP780","wrapper":"CustomScroller_wrapper__62Zdn","inner":"CustomScroller_inner__4mhRB"};